"use client";
import React, { useRef } from "react";
import { motion } from 'framer-motion'

export function EngagementTriangle() {
  const containerRef = useRef<HTMLDivElement>(null);

  const diffRefs = [
    useRef<HTMLDivElement>(null),
    useRef<HTMLDivElement>(null),
    useRef<HTMLDivElement>(null),
  ];

  const differentials = [
    {
      title: "Inovação",
      description: "Criatividade aplicada em soluções reais",
    },
    {
      title: "Mercado",
      description: "Conexão direta com demandas atuais",
    },
    {
      title: "Academia",
      description: "Base científica sólida e aplicada",
    },
  ];

  const angles = [90, 210, 330];
  const radius = 130;

  return (
    <motion.div
      className="relative md:w-[360px] md:h-[360px] w-[280px] h-[280px] mx-auto flex items-center justify-center md:mb-8 mb-6"
      ref={containerRef}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.5 }}
    >
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2
             rounded-full border-2 border-gray-300
             md:w-[280px] md:h-[280px] w-[240px] h-[240px] flex items-center justify-center z-10"
      >
        <div
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2
               rounded-full border-t-2 border-[#307AFF]
               md:w-[280px] md:h-[280px] w-[240px] h-[240px] animate-spin-slow"
        />
      </div>

      {differentials.map(({ title, description }, i) => {
        const angleRad = ((angles[i] + 180) * Math.PI) / 180;
        const x = radius * Math.cos(angleRad);
        const y = radius * Math.sin(angleRad);

        return (
          <div
            key={i}
            ref={diffRefs[i]}
            className="absolute z-10 max-w-[120px] text-center bg-white z-999"
            style={{
              transform: `translate(${x}px, ${y}px)`,
            }}
          >
            <p className="font-bold text-blue-600 text-lg">{title}</p>
            <span className="text-sm text-gray-600">{description}</span>
          </div>
        );
      })}
    </motion.div>
  );
}
